<template>
  <v-container>
    <v-btn absolute top right icon @click="exportHistoryToCSV">
      <v-icon>mdi-tray-plus</v-icon>
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="history"
      :loading="loading"
      :single-expand="singleExpand"
      :options.sync="options"
      loading-text="Loading... Please wait"
      show-expand
      hide-default-footer
      :items-per-page="items_per_page"
    >
      <template v-slot:no-data>
        <v-alert type="info" class="ma-2">No history records found</v-alert>
      </template>
      <template v-slot:item.card_expire="{ item }">
        {{ formatDate(item.card_expire) }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ formatDateAndTime(item.created_at) }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Title</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in item" :key="key">
                <td>{{ key }}</td>
                <td>{{ value }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
    <Paginate :meta="meta" v-on:paginate="paginateAction" />
  </v-container>
</template>

<style scoped>
::v-deep .v-data-table__expanded__content {
  box-shadow: none !important;
}
</style>

<script>
import store from '@/store/index';
import { mapGetters } from 'vuex';
import { dateMixin } from '@/mixins/dateMixin';
import ReportService from '@/services/ReportService';
import { getError } from '@/utils/helpers';
import Paginate from '@/views/Paginate';

export default {
  name: 'FamilyMemberHistory',
  mixins: [dateMixin],
  components: {
    Paginate
  },
  data() {
    return {
      singleExpand: true,
      options: {},
      items_per_page: 10,
      headers: [
        { text: 'Card Status', value: 'card_status', sortable: true },
        { text: 'Card Number', value: 'card_number', sortable: true },
        { text: 'Card Expire', value: 'card_expire', sortable: true },
        { text: 'Changed By', value: 'username', sortable: true },
        { text: 'Date', value: 'created_at', sortable: true },
        { text: '', value: 'data-table-expand' }
      ]
    };
  },
  computed: {
    ...mapGetters('family', ['familyMember', 'history', 'loading', 'meta', 'links'])
  },
  methods: {
    /**
     * Load the familyMember
     */
    loadAction: function () {
      if (this.familyMember.id) {
        store.dispatch('family/history', {
          id: this.familyMember.id,
          page: this.options.page || 1,
          per_page: this.items_per_page,
          sort_by: this.options.sortBy?.[0] ?? 'created_at',
          sort_desc: this.options.sortDesc?.[0] ?? true
        });
      }
    },
    /**
     * Handle pagination events
     */
    paginateAction(item) {
      if (item === 'next') {
        store.dispatch('family/paginateHistory', this.links.next);
      } else if (item === 'previous') {
        store.dispatch('family/paginateHistory', this.links.prev);
      }
    },
    /**
     * Create the file name for the export
     */
    filename(reportFilenamePrefix, extension) {
      return reportFilenamePrefix.replace(/[^a-z0-9]/gi, '-') + '.' + extension;
    },
    async exportHistoryToCSV() {
      if (!this.history || !this.history.length) {
        alert('No history data to export.');
        return;
      }
      const filetype = 'csv';
      await ReportService.getReport({
        report: 'family-member-history',
        filename: this.filename(
          'family-member-history-' + this.familyMember.first_name + '-' + this.familyMember.surname,
          filetype
        ),
        filetype: filetype,
        id: this.familyMember.id
      }).catch(error => {
        store.dispatch('ui/snackbarError', getError(error));
      });
    }
  },
  watch: {
    familyMember: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadAction();
        }
      },
      immediate: true
    },
    options: {
      handler() {
        if (this.familyMember && this.familyMember.id) {
          this.loadAction();
        }
      },
      deep: true
    }
  }
};
</script>
